var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userLicense.expiresSoon && !_vm.userLicense.isLicenseExpired)?_c('div',{staticClass:"font-semibold cursor-pointer text-danger text-xs md:text-sm text-right"},[_vm._v(" "+_vm._s(_vm.licenseExpireDate)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }